// extracted by mini-css-extract-plugin
export default {"input":"ff4a2b54ac904740"};